import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetThisWeekJobsQueryVariables = Types.Exact<{
  where: Types.ProductionJobDocumentFilterInput;
  order: Array<Types.ProductionJobDocumentSortInput> | Types.ProductionJobDocumentSortInput;
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetThisWeekJobsQuery = { __typename?: 'Query', productionJobs?: { __typename?: 'ProductionJobsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionJobDocument', lotClosedStatus: Types.LotClosedStatus, startedAt?: Types.TDateISO | null, startedBy?: string | null, doneAt?: Types.TDateISO | null, doneBy?: string | null, id: string, tenantId: string, productionLotId: string, productionPlanId: string, productionPlanName: string, productionJobId: string, parentProductionJobId?: string | null, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, customerId?: string | null, customerName?: string | null, locationId?: string | null, locationName?: string | null, categoryName: string, genus: string, series: string, color: string, jobNumber: number, jobExecutionStatus: Types.JobExecutionStatus, postingStatus: Types.JobPostingStatus, quantity: number, exactQuantity?: number | null, isQuantityOverridden: boolean, yield: number, yieldOverride?: number | null, isYieldOverridden: boolean, growWeeksOverride?: number | null, isGrowWeeksOverridden: boolean, plantsPerPotOverride?: number | null, isPlantsPerPotOverridden: boolean, plannedHoursOverride?: number | null, plannedHoursSource: Types.PlannedHoursSource, weekReadyDate: Types.TDateISO, weekReadyIsoWeek: number, weekReadyIsoYear: number, weekStartDate: Types.TDateISO, weekStartIsoWeek: number, weekStartIsoYear: number, lotStatus: Types.ProductionLotStatus, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, isRecipeStale: boolean, lastReconciledRecipeVersion: number, actualYield: number, producedQuantity?: number | null, producedLocationId?: string | null, countedAt?: Types.TDateISO | null, unitLabel: string, eaches: number, requestedEaches: number, eachesPerUnit?: number | null, expectedOutputEaches: number, actualYieldEaches: number, yieldVarianceEaches: number, producedLocations: Array<{ __typename?: 'ProducedLocationQuantity', locationId: string, locationName?: string | null, quantity: number }>, shrinkEvents: Array<{ __typename?: 'ProductionJobShrinkEventDocument', shrinkEventId: string, shrinkType: Types.ShrinkType, quantity: number, date: Types.TDateISO, notes?: string | null, recordedAt: Types.TDateISO, recordedBy: string }>, shrinkEventEaches: Array<{ __typename?: 'ProductionJobShrinkEventEachesData', shrinkEventId: string, eaches: number }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetThisWeekLotsQueryVariables = Types.Exact<{
  where: Types.ProductionLotDocumentFilterInput;
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetThisWeekLotsQuery = { __typename?: 'Query', productionLots?: { __typename?: 'ProductionLotsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionLotDocument', productionLotId: string, lotNumber: number, quantity: number }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetThisWeekTaskAssignmentsQueryVariables = Types.Exact<{
  where: Types.TaskAssignmentDocumentFilterInput;
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetThisWeekTaskAssignmentsQuery = { __typename?: 'Query', taskAssignments?: { __typename?: 'TaskAssignmentsConnection', totalCount: number, nodes?: Array<{ __typename?: 'TaskAssignmentDocument', taskAssignmentId: string, productionJobId?: string | null, productionTaskEventDetailId?: string | null, taskEventName: string, status: Types.TaskAssignmentStatus, completedAt?: Types.TDateISO | null, completedBy?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type ThisWeekJobFragment = { __typename?: 'ProductionJobDocument', lotClosedStatus: Types.LotClosedStatus, startedAt?: Types.TDateISO | null, startedBy?: string | null, doneAt?: Types.TDateISO | null, doneBy?: string | null, id: string, tenantId: string, productionLotId: string, productionPlanId: string, productionPlanName: string, productionJobId: string, parentProductionJobId?: string | null, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, customerId?: string | null, customerName?: string | null, locationId?: string | null, locationName?: string | null, categoryName: string, genus: string, series: string, color: string, jobNumber: number, jobExecutionStatus: Types.JobExecutionStatus, postingStatus: Types.JobPostingStatus, quantity: number, exactQuantity?: number | null, isQuantityOverridden: boolean, yield: number, yieldOverride?: number | null, isYieldOverridden: boolean, growWeeksOverride?: number | null, isGrowWeeksOverridden: boolean, plantsPerPotOverride?: number | null, isPlantsPerPotOverridden: boolean, plannedHoursOverride?: number | null, plannedHoursSource: Types.PlannedHoursSource, weekReadyDate: Types.TDateISO, weekReadyIsoWeek: number, weekReadyIsoYear: number, weekStartDate: Types.TDateISO, weekStartIsoWeek: number, weekStartIsoYear: number, lotStatus: Types.ProductionLotStatus, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, isRecipeStale: boolean, lastReconciledRecipeVersion: number, actualYield: number, producedQuantity?: number | null, producedLocationId?: string | null, countedAt?: Types.TDateISO | null, unitLabel: string, eaches: number, requestedEaches: number, eachesPerUnit?: number | null, expectedOutputEaches: number, actualYieldEaches: number, yieldVarianceEaches: number, producedLocations: Array<{ __typename?: 'ProducedLocationQuantity', locationId: string, locationName?: string | null, quantity: number }>, shrinkEvents: Array<{ __typename?: 'ProductionJobShrinkEventDocument', shrinkEventId: string, shrinkType: Types.ShrinkType, quantity: number, date: Types.TDateISO, notes?: string | null, recordedAt: Types.TDateISO, recordedBy: string }>, shrinkEventEaches: Array<{ __typename?: 'ProductionJobShrinkEventEachesData', shrinkEventId: string, eaches: number }> };

export const ThisWeekJobFragmentDoc = new TypedDocumentString(`
    fragment ThisWeekJob on ProductionJobDocument {
  producedLocations {
    locationId
    locationName
    quantity
  }
  ...ProductionJobSummary
  lotClosedStatus
  startedAt
  startedBy
  doneAt
  doneBy
}
    fragment ProductionJobSummary on ProductionJobDocument {
  id
  tenantId
  productionLotId
  productionPlanId
  productionPlanName
  productionJobId
  parentProductionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  customerId
  customerName
  locationId
  locationName
  categoryName
  genus
  series
  color
  jobNumber
  jobExecutionStatus
  postingStatus
  quantity
  exactQuantity
  isQuantityOverridden
  yield
  yieldOverride
  isYieldOverridden
  growWeeksOverride
  isGrowWeeksOverridden
  plantsPerPotOverride
  isPlantsPerPotOverridden
  plannedHoursOverride
  plannedHoursSource
  weekReadyDate
  weekReadyIsoWeek
  weekReadyIsoYear
  weekStartDate
  weekStartIsoWeek
  weekStartIsoYear
  lotStatus
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  isRecipeStale
  lastReconciledRecipeVersion
  actualYield
  producedQuantity
  producedLocationId
  countedAt
  shrinkEvents {
    shrinkEventId
    shrinkType
    quantity
    date
    notes
    recordedAt
    recordedBy
  }
  unitLabel
  eaches
  requestedEaches
  eachesPerUnit
  expectedOutputEaches
  actualYieldEaches
  yieldVarianceEaches
  shrinkEventEaches {
    shrinkEventId
    eaches
  }
}`, {"fragmentName":"ThisWeekJob"});
export const GetThisWeekJobsDocument = new TypedDocumentString(`
    query GetThisWeekJobs($where: ProductionJobDocumentFilterInput!, $order: [ProductionJobDocumentSortInput!]!, $first: Int!, $after: String) {
  productionJobs(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      ...ThisWeekJob
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ThisWeekJob on ProductionJobDocument {
  producedLocations {
    locationId
    locationName
    quantity
  }
  ...ProductionJobSummary
  lotClosedStatus
  startedAt
  startedBy
  doneAt
  doneBy
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
fragment ProductionJobSummary on ProductionJobDocument {
  id
  tenantId
  productionLotId
  productionPlanId
  productionPlanName
  productionJobId
  parentProductionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  customerId
  customerName
  locationId
  locationName
  categoryName
  genus
  series
  color
  jobNumber
  jobExecutionStatus
  postingStatus
  quantity
  exactQuantity
  isQuantityOverridden
  yield
  yieldOverride
  isYieldOverridden
  growWeeksOverride
  isGrowWeeksOverridden
  plantsPerPotOverride
  isPlantsPerPotOverridden
  plannedHoursOverride
  plannedHoursSource
  weekReadyDate
  weekReadyIsoWeek
  weekReadyIsoYear
  weekStartDate
  weekStartIsoWeek
  weekStartIsoYear
  lotStatus
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  isRecipeStale
  lastReconciledRecipeVersion
  actualYield
  producedQuantity
  producedLocationId
  countedAt
  shrinkEvents {
    shrinkEventId
    shrinkType
    quantity
    date
    notes
    recordedAt
    recordedBy
  }
  unitLabel
  eaches
  requestedEaches
  eachesPerUnit
  expectedOutputEaches
  actualYieldEaches
  yieldVarianceEaches
  shrinkEventEaches {
    shrinkEventId
    eaches
  }
}`);
export const GetThisWeekLotsDocument = new TypedDocumentString(`
    query GetThisWeekLots($where: ProductionLotDocumentFilterInput!, $first: Int!, $after: String) {
  productionLots(where: $where, first: $first, after: $after) {
    nodes {
      productionLotId
      lotNumber
      quantity
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetThisWeekTaskAssignmentsDocument = new TypedDocumentString(`
    query GetThisWeekTaskAssignments($where: TaskAssignmentDocumentFilterInput!, $first: Int!, $after: String) {
  taskAssignments(where: $where, first: $first, after: $after) {
    nodes {
      taskAssignmentId
      productionJobId
      productionTaskEventDetailId
      taskEventName
      status
      completedAt
      completedBy
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetThisWeekJobs: build.query<GetThisWeekJobsQuery, GetThisWeekJobsQueryVariables>({
      query: (variables) => ({ document: GetThisWeekJobsDocument, variables })
    }),
    GetThisWeekLots: build.query<GetThisWeekLotsQuery, GetThisWeekLotsQueryVariables>({
      query: (variables) => ({ document: GetThisWeekLotsDocument, variables })
    }),
    GetThisWeekTaskAssignments: build.query<GetThisWeekTaskAssignmentsQuery, GetThisWeekTaskAssignmentsQueryVariables>({
      query: (variables) => ({ document: GetThisWeekTaskAssignmentsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetThisWeekJobsQuery, useLazyGetThisWeekJobsQuery, useGetThisWeekLotsQuery, useLazyGetThisWeekLotsQuery, useGetThisWeekTaskAssignmentsQuery, useLazyGetThisWeekTaskAssignmentsQuery } = injectedRtkApi;
